<template>
    <app-layout>
        <v-dialog
            persistent
            :value="true"
            >
            <div class="flex flex-col w-1/2 bg-white mx-auto  gap-7 border-t-4 border-gray-600 px-8 md:px-28 pt-4 sm:pt-12 pb-14 text-center">
                <h1 class="py-2">{{ title }}</h1>

                <div v-show="step == 0" class="flex-col">
                    <h2 class="px-4 underline text-black">Once enabled, two factor authentication will prompt you for a security confirmation code during
                        logins.</h2>
                    <div class="flex flex-col mx-auto my-4 p-4">
                        <h3>To enable 2FA on your account:</h3>
                        <h4>Enter your cell phone number</h4>
                        <h4>Click the "Request a code by SMS" button</h4>
                    </div>
                    <v-text-field
                        label="Cell Phone Number"
                        id="mobile_phone"
                        type="text"
                        v-model="user.mobile_phone"
                        class="px-2 w-75 mx-auto"
                        outlined
                        maxlength="10"
                        :rules="rules.phoneNumber"
                        hint="Only digits, no dash or space."
                        autocomplete="off"
                        style="width: 250px !important"
                    ></v-text-field>

                    <v-btn color="primary" elevation="0" class="filter_btn" :class="{ 'opacity-25': enabling }" :disabled="enabling" @click="enableTwoFactorAuthentication">
                        Request a code by SMS
                    </v-btn>

                    <v-btn color="primary" elevation="0" class="filter_btn" :class="{ 'opacity-25': enabling }" :disabled="enabling" @click="enableTwoFactorAuthentication('voice')">
                        Request a code by Phone Call
                    </v-btn>

                </div>

                <div v-show="step == 1">
                    <h4 class="text-md mb-5">
                        Enter and confirm the code you received.
                    </h4>

                    <v-text-field
                        label="Confirmation Code"
                        autocomplete="off"
                        id="code"
                        type="text"
                        v-model="twoFactorCode"
                        outlined
                    ></v-text-field>

                    <v-btn class="primary" elevation="0" :class="{ 'opacity-25': enabling }" :disabled="enabling" @click="confirmTwoFactorAuthentication">
                        Confirm code
                    </v-btn>
                </div>

                <div v-show="step == 'last'">
                    <h3 class="text-md mb-5">
                        2FA is now enabled for more secure access to your account.
                    </h3>

                    <v-btn class="primary" elevation="0" :class="{ 'opacity-25': enabling }" :disabled="enabling" @click="login">
                        Login
                    </v-btn>
                </div>

            </div>
        </v-dialog>

    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'

export default {
    components: {
        AppLayout,
    },

    props: {
        'input': {
            // Current user
            type: Object,
            required: true,
            default: function () {
                return undefined
            }
        },
    },

    data() {
        return {
            title: 'Set up 2FA on your account',
            user: this.input || null,
            enabling: false,
            disabling: false,
            showConfirmation: false,
            show2fasteps: false,
            step: 0,
            twoFactorCode: null,
            enableForm: {
                mobilePhone: null,
            },
            recoveryCodes: [],
            qrCode: null,
            rules: {
                phoneNumber: [
                    v => (!isNaN(parseFloat(v)) && v >= 0) || 'Only digits, no dash or space.'
                ],
            },

        }
    },

    mounted() {

    },

    methods: {

        lastStep() {
            this.title = 'Congratulations !'
            this.step = 'last'
        },

        login() {
            this.enabling = true
            window.location.replace('/login')
        },

        errorHandler(error) {
            if( error.response?.data && typeof error.response.data.errors === 'object'){
                var errorDetail = Object.values(error.response.data.errors)[0][0]
                this.$root.snackbar.error(errorDetail)
            }
            else {
                this.$root.snackbar.error(error)
            }
            console.log(error)

        },

        enableTwoFactorAuthentication(code_method) {
            code_method = code_method || 'text'
            if(this.user.mobile_phone !== null) {
                this.enabling = true

                axios.post('/user/two-factor-authentication', { mobilePhone: this.user.mobile_phone, code_method: code_method })
                    .then(response => {
                        console.log(response)
                        if(response.data.success) {
                            this.title = '2FA Confirmation Code'
                            this.step = 1
                            this.$root.snackbar.success('A unique code has been sent by SMS')
                        } else {
                            this.$root.snackbar.error('Request failed')
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error('Request failed for this cell phone')
                    })
                    .finally(() => {
                        this.enabling = false
                    })
            } else {
                this.$root.snackbar.error('Please enter your cell phone number')
            }
        },

        confirmTwoFactorAuthentication() {
            axios.post('/user/two-factor-confirm', { code: this.twoFactorCode })
                .then(response => {
                    if(response.data.confirmed) {
                        this.user.two_factor_confirmed = response.data.confirmed
                        this.$root.snackbar.success('Code confirmed with success')
                        this.lastStep()

                    } else {
                        this.$root.snackbar.error('Could not confirm your security code')
                    }
                }).catch((error) => {
                    this.$root.snackbar.error('Request failed for code confirmation')
                })
                .finally(() => {
                    this.enabling = false
                })
        },

        getRecoveryCodes() {
            this.enabling = true
            axios.get('/user/two-factor-recovery-codes', { code: this.twoFactorCode })
                .then(response => {
                    if(response.data) {
                        this.recoveryCodes = response.data
                    } else {
                        this.$root.snackbar.error('Error: Could not get your recovery codes')
                    }
                })
                .catch((error) => {
                    this.$root.snackbar.error('Request failed for getting your recovery codes')
                })
                .finally(() => {
                    this.enabling = false
                })
        },
    },

    computed: {
        twoFactorConfirmed() {
            return !!this.user.two_factor_confirmed
        }
    }
}
</script>

<style scoped>
.mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.shadow {

}
.primary-button {
    margin: 0.25rem;
    margin-top: 1.75rem;
    display: block;
    cursor: pointer;
    border-radius: 0.25rem;
    border-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgba(148, 0, 4, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(148, 0, 4, var(--tw-bg-opacity));
}
</style>
